import React from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { InvalidCriteriaMessage } from "../shared/InvalidCriteriaMessage";
import { Input } from "../shared/Input";
import { genders } from "../../../shared/definitions/other/Gender";
import { gameStore } from "../../stores/GameStore";
const CharacterData = styled.div.withConfig({
  displayName: "EditorSingleCharacterPropertiesGame__CharacterData",
  componentId: "sc-7fo250-0"
})(["align-self:flex-start;flex-grow:1;"]);
const CharacterField = styled.div.withConfig({
  displayName: "EditorSingleCharacterPropertiesGame__CharacterField",
  componentId: "sc-7fo250-1"
})(["display:flex;flex-direction:column;margin-bottom:16px;"]);
const CharacterSubField = styled.div.withConfig({
  displayName: "EditorSingleCharacterPropertiesGame__CharacterSubField",
  componentId: "sc-7fo250-2"
})(["margin-left:16px;display:flex;flex-direction:column;"]);
export const EditorSingleCharacterPropertiesGame = observer(() => {
  const {
    t
  } = useTranslation();
  const hasName = gameStore.playerName;
  return /*#__PURE__*/React.createElement(CharacterData, null, /*#__PURE__*/React.createElement(CharacterField, null, /*#__PURE__*/React.createElement("br", null), t("game.character_config_name_game"), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    value: gameStore.playerName,
    onChange: e => gameStore.setPlayerName(e.target.value),
    className: hasName ? "" : "invalid"
  }), !hasName && /*#__PURE__*/React.createElement(InvalidCriteriaMessage, null, t("editor.invalid_name_criteria_name_empty"))), /*#__PURE__*/React.createElement(CharacterField, null, t("game.character_config_gender"), /*#__PURE__*/React.createElement(CharacterSubField, null, genders.map(gender => /*#__PURE__*/React.createElement("label", {
    key: gender
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: "gender",
    value: gender,
    checked: gameStore.playerGender === gender,
    onChange: () => gameStore.setPlayerGender(gender)
  }), "\xA0", t("game.character_config_gender_option" + gender))))));
});